<template>
  <div class="referral">
    <section class="page-section">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1 class="section-title">
              {{ $t('label.title.referPeopleYouKnow') }}
            </h1>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-5 col-lg-4">
                <div class="row">
                  <div class="col-md-12">
                    <div class="mb-3">
                      <input
                        :placeholder="$t('input.placeholder.nameOfYourFriends')"
                        class="form-control form-input"
                        type="text"
                        v-model="friendName"
                        :class="messageValidate && messageValidate.hasOwnProperty('referee_name') ? 'form-input-error': '' "
                      >
                      <span
                        class="label-error mb-2"
                        v-if="messageValidate && messageValidate.hasOwnProperty('referee_name')"
                      >
                        {{ messageErrorLabels.referee_name }}
                      </span>
                    </div>

                    <div class="mb-3">
                      <input
                        :placeholder="$t('input.placeholder.theirContactNumber')"
                        class="form-control form-input"
                        type="text"
                        v-model="friendContact"
                        v-mask="'0## ### ####'"
                        :class="messageValidate && messageValidate.hasOwnProperty('referee_phone') ? 'form-input-error': '' "
                      >
                      <span
                        class="label-error mb-2"
                        v-if="messageValidate && messageValidate.hasOwnProperty('referee_phone')"
                      >
                        {{ messageErrorLabels.referee_phone }}
                      </span>
                    </div>

                    <div class="mb-3">
                      <input
                        :placeholder="$t('input.placeholder.yourName')"
                        class="form-control form-input"
                        type="text"
                        v-model="yourName"
                        :class="messageValidate && messageValidate.hasOwnProperty('referred_name') ? 'form-input-error': '' "
                      >
                      <span
                        class="label-error mb-2"
                        v-if="messageValidate && messageValidate.hasOwnProperty('referred_name')"
                      >
                        {{ messageErrorLabels.referred_name }}
                      </span>
                    </div>

                    <div class="mb-3">
                      <input
                        :placeholder="$t('input.placeholder.yourContactNumber')"
                        class="form-control form-input"
                        type="text"
                        v-model="yourContact"
                        v-mask="'0## ### ####'"
                        :class="messageValidate && messageValidate.hasOwnProperty('referred_phone') ? 'form-input-error': '' "
                      >
                      <span
                        class="label-error mb-2"
                        v-if="messageValidate && messageValidate.hasOwnProperty('referred_phone')"
                      >
                        {{ messageErrorLabels.referred_phone }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 mt-3">
                    <g-recaptcha
                      :sitekey="sitekey"
                      :callback="callback"
                    />
                    <span
                      class="label-error"
                      v-if="messageValidate && messageValidate.hasOwnProperty('recaptcha_response')"
                    >
                      {{ messageErrorLabels.recaptcha_response }}
                    </span>
                  </div>
                  <div class="col-md-12 mt-3">
                    <button
                      type="submit"
                      class="full-button"
                      @click="onSubmit"
                    >
                      {{ $t('referral.button.submitReferral').toUpperCase() }}
                    </button>
                  </div>
                  <div class="button-condition">
                    {{ $t('label.condition.referral') }}
                  </div>
                </div>
              </div>
              <div class="offset-md-1 offset-lg-1" />
              <div class="col-md-6 col-lg-7">
                <div class="referral-policy mt-4 mt-md-0 ml-lg-5 mr-lg-5 content-weight">
                  <h4 class="mb-4 mt-4">
                    {{ $t('referral.title.referralPolicy') }}
                  </h4>
                  <template v-if="$i18n.locale === 'en'">
                    <referral-english />
                  </template>
                  <template v-else>
                    <referral-khmer />
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="container-fluid position-relative">
        <div class="position-absolute footer-footer" />
        <div class="container">
          <div class="row">
            <div
              class="col-md-12"
              style="padding: 0"
            >
              <img
                src="img/footer-ref.png"
                alt=""
                style="width: 100%"
              >
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'
import gRecaptcha from './../components/recaptcha.vue'
import ReferralEnglish from './../components/documents/referral/ReferralEnglish'
import ReferralKhmer from './../components/documents/referral/ReferralKhmer'
export default {
  name: 'Referral',
  directives: { mask },
  components: { gRecaptcha, ReferralEnglish, ReferralKhmer },
  metaInfo: {
    title: 'Referral',
    titleTemplate: '%s | Cash Hero',
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: 'Referral Cash hero website' }
    ]
  },
  data () {
    return {
      friendName: '',
      friendContact: '',
      yourName: '',
      yourContact: '',
      messageValidate: '',
      baseUrl: process.env.VUE_APP_BASE_URL,
      sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      recaptchaToken: null,

      messageErrorLabels: {
        self: this,
        get referee_name () { return this.self.$t('messageError.label.refereeName') },
        get referee_phone () { return this.self.$t('messageError.label.refereePhone') },
        get referred_name () { return this.self.$t('messageError.label.referredName') },
        get referred_phone () { return this.self.$t('messageError.label.referredPhone') },
        get recaptcha_response () { return this.self.$t('messageError.label.recaptcha') }
      }
    }
  },
  methods: {
    callback (token) {
      this.recaptchaToken = token
    },
    resetRecaptcha () {
      window.grecaptcha.reset(0)
      this.recaptchaToken = null
    },
    onSubmit () {
      this.messageValidate = ''
      this.$axios.post(this.baseUrl + '/api/v1/refers/store', {
        referee_name: this.friendName,
        referee_phone: this.splitSpace(this.friendContact),
        referred_name: this.yourName,
        referred_phone: this.splitSpace(this.yourContact),
        recaptcha_response: this.recaptchaToken
      }).then((response) => {
        if (response.data.code === 1) {
          this.friendName = ''
          this.friendContact = ''
          this.yourName = ''
          this.yourContact = ''
          this.messageValidate = ''
          this.$swal.fire({
            type: 'success',
            title: this.$t('messageSuccess.title.submitBorrow'),
            text: this.$t('messageSuccess.label.submitRefer')
          })
        } else {
          this.messageValidate = response.data.message
          if (!(typeof this.messageValidate === 'object')) {
            this.$swal.fire({
              type: 'error',
              title: this.$t('messageError.title.serverError'),
              text: this.$t('messageError.label.serverError'),
              confirmButtonColor: '#3c56a0'
            })
          }
        }
      })
      this.resetRecaptcha()
    },
    splitSpace (string) {
      return string.split(' ').join('')
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
    .referral-policy {
        padding: 20px;
        border-radius: 10px;
        background-color: var(--shade);
    }

    .footer-footer {
      background-color: var(--primary);
      width: 100%;
      bottom: 0;
      left: 0;
      right: 0;
      height: 20%;
    }
</style>
